export default {"src":"/_next/static/media/customer-everlane.b6dd5796.svg","height":57,"width":600};